import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { Consumable } from 'src/app/util/interfaces/stockConsumables';
import { environment } from 'src/environments/environment';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import { ciInterface } from 'src/app/util/interfaces/ci';

@Injectable({
	providedIn: 'root',
})
export class CmdbReportPageService {
	private getFormOptionsUrl = environment.baseApiUrl + 'reportcmdb/report/params/{qryString}';
	private getReportUrl = environment.baseApiUrl + 'reportcmdb/report/{qryName}?{qryString}';
	private getReport = environment.baseApiUrl + 'reportcmdb/report/{qryName}';
	private getNewItemsByDate = environment.baseApiUrl + 'reportcmdb/report/{qryString}';
	private getQrCodeCis = environment.baseApiUrl + 'load/cmdb/qrcode';
	private getBarCodeCis = environment.baseApiUrl + 'load/cmdb/barcode';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	getReportData(dateString: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getReportUrl = this.getNewItemsByDate.replace('{qryString}', dateString);
		return this.http.get(getReportUrl, { headers: headers });
	}

	getFormOptions(formOption: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		formOption = this.getFormOptionsUrl.replace('{qryString}', formOption);

		return this.http.get<JSON[]>(formOption, { headers: headers }).pipe(
			map((formOptionsRes) => {
				const newFormOptionsArray: genericFormInterface[] = [];
				formOptionsRes.forEach((formOption: any) => {
					const newFormOption: genericFormInterface = {
						//"id" : formOption.id,
						inputType: formOption.type_param,
						//"reportName" : "",
						name: formOption.name_param,
						label: formOption.label_param,
						//"regex" : formOption.regex,
						selected: formOption.selected_param,
						items: [],
						values: [''],
					};

					if (formOption.items && formOption.items.length > 0) {
						formOption.items.forEach((item: any) => {
							const newItem: genericFormInterface['items'][number] = {
								label: item.label_item,
								name: item.name_item,
								values: [item.value_item],
							};

							newFormOption.items.push(newItem);
						});
					}

					newFormOptionsArray.push(newFormOption);
				});

				return newFormOptionsArray;
			})
		);
	}

	createReport(spreadsheetView: string, reportParameters: genericFormInterface[]) {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		if (reportParameters.length === 0) {
			return this.http.get<Consumable[]>(this.getReport.replace('{qryName}', spreadsheetView), { headers: headers });
		}
		let query = '';

		for (const [index, reportForm] of reportParameters.entries()) {
			let concatStock = '';

			for (const [index2, value] of reportForm.values.entries()) {
				if (reportForm.name === 'date_range') {
					if (index2 === 0) {
						reportForm.values[0] === '' ? '' : (concatStock += 'start_date=' + value);
					}

					if (index2 === 1) {
						reportForm.values[1] === '' ? '' : (concatStock += 'end_date=' + value);
					}
				} else {
					concatStock = concatStock.concat(reportForm.name + '=' + value);
				}

				if (index !== reportParameters.length - 1 || index2 !== reportForm.values.length - 1) {
					concatStock += '&';
				}
			}

			query += concatStock;
		}

		const reportUrl = this.getReportUrl.replace('{qryString}', query).replace('{qryName}', spreadsheetView);

		return this.http.get<Consumable[]>(reportUrl, { headers: headers });
	}

	exportExcel(): void {
		const element = document.querySelector('#excel-table');
		const date = new Date();
		const dateFormatted = date.getMonth() + 1 + '-' + date.getDate() + '-' + date.getFullYear();
		const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { dateNF: 'mm/dd/yyyy', cellDates: true, raw: true });
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
		XLSX.writeFile(wb, 'ExportCMDB_' + dateFormatted + '.xlsx');
	}

	getAllQrCodes(): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get<any>(this.getQrCodeCis, { headers: headers });
	}

	getAllBarCodes(): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get<any>(this.getBarCodeCis, { headers: headers });
	}
}
